import { useField, useFormikContext } from 'formik';
import type { ReactNode } from 'react';

import Chip from '../../InputFields/Chip';

interface FormikChipProps {
  name: string;
  label: string;
  value: string;
  disabled?: boolean;
  icon?: ReactNode;
  pictureProps?: {
    src?: string;
    alt?: string;
    title?: string;
    'aria-label'?: string;
  } | null;
  transparentBg?: boolean;
}

export const FormikChip: React.FC<FormikChipProps> = ({
  name,
  label,
  value,
  disabled = false,
  icon = null,
  pictureProps = null,
  transparentBg = true,
}) => {
  const [field] = useField(name);
  const { setFieldValue } = useFormikContext();

  let fieldValue: string[] = [];
  if (Array.isArray(field.value)) {
    fieldValue = field.value as string[];
  } else if (field.value) {
    fieldValue = [field.value as string];
  }

  const isSelected = fieldValue.includes(value);

  const handleSelect = () => {
    setFieldValue(name, [...fieldValue, value]);
  };

  const handleDeselect = () => {
    setFieldValue(
      name,
      fieldValue.filter(item => item !== value)
    );
  };

  return (
    <Chip
      label={label}
      selected={isSelected}
      disabled={disabled}
      onSelect={handleSelect}
      onDeselect={handleDeselect}
      {...(pictureProps && { pictureProps })}
      {...(icon && { icon })}
      transparentBg={transparentBg}
    />
  );
};
